import { render, staticRenderFns } from "./monthly-indicators.vue?vue&type=template&id=1023db67&scoped=true"
import script from "./monthly-indicators.vue?vue&type=script&lang=js"
export * from "./monthly-indicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023db67",
  null
  
)

export default component.exports